import React from 'react'
import { EmptyPlaceholder } from '@components/common'

type PaymentMethod = 'PayPal' | 'Venmo' | 'CashApp' | 'Other'

type OtherFormProps = {
  selectedMethod: PaymentMethod
}

const OtherForm: React.FC<OtherFormProps> = ({ selectedMethod }) => (
  <EmptyPlaceholder
    title={`${selectedMethod} is not yet implemented`}
    content="This payment method is not available yet."
    icon="mgc_information_fill"
  />
)

export default OtherForm
